import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import Scheduletate, {HodidayList, ScheduleList} from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'

const actions: ActionTree<Scheduletate, State> = {
  async getScheduleList(
    { commit, dispatch, state }: ActionContext<Scheduletate, State>,
    options: object,
  ): Promise<void> {
    await HttpRequestServiceWithToken
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'schedule', options, (res: ScheduleList) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
  async putSchedule(
    { commit, dispatch, state }: ActionContext<Scheduletate, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
      .putByLevel(
        process.env.VUE_APP_API_URL + '/v1', `schedule/${id}`, options, (res: object) => {
        commit(mutationType.UPDATE, res)
      })
  },
  async getScheduleListByUser(
    { commit, dispatch, state }: ActionContext<Scheduletate, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    await HttpRequestServiceWithToken
      .get(process.env.VUE_APP_API_URL + '/v1/user/schedule/user', options, (res: ScheduleList) => {
        commit(mutationType.GET_LIST_BY_USER, res)
      })
  },
  async putStopSchedule(
    { commit, dispatch, state }: ActionContext<Scheduletate, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
      .putByLevel(
        process.env.VUE_APP_API_URL + '/v1', `schedule/${id}/caregiver`, options, (res: object) => {
        commit(mutationType.STOP_JOB, res)
      })
  },
  async putScheduleStatus(
    { commit, dispatch, state }: ActionContext<Scheduletate, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
      .putByLevel(
        process.env.VUE_APP_API_URL + '/v1', `schedule/status/${id}`, options, (res: object) => {
        commit(mutationType.UPDATE, res)
      })
  },
  async putScheduleLogs(
    { commit, dispatch, state }: ActionContext<Scheduletate, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
      .putByLevel(process.env.VUE_APP_API_URL + '/v1', `schedule/logs/${id}`, options, (res: ScheduleList) => {
        // commit(mutationType.UPDATE_LOGS, res)
      })
  },
  async getHodidayList(
    { commit, dispatch, state }: ActionContext<Scheduletate, State>,
    options: object,
  ): Promise<void> {
    await HttpRequestServiceWithToken
      .get(process.env.VUE_APP_API_URL + '/v1/all/schedule/holiday', options, (res: HodidayList) => {
        commit(mutationType.GET_HOLIDAY_LISTS, res)
      })
  },
  async getScheduleJobLogList(
    { commit, dispatch, state }: ActionContext<Scheduletate, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', `schedule/job/${id}`, options, (res) => {
        commit(mutationType.GET_SCHEDULE_JOB_LOG, res)
      })
  },
  async getSchedulePatientLogList(
    { commit, dispatch, state }: ActionContext<Scheduletate, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await HttpRequestServiceWithToken
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', `schedule/patient/${id}`, options, (res) => {
        commit(mutationType.GET_SCHEDULE_PATIENT_LOG, res)
      })
  },
}

export default actions
